<div class="homePage" id="homeContainer">
  <div class="homeAppName">
    <div>
      <div class="appName">MERA REPORTING</div>
      <div class="apptagline">
        MERA Reporting is a cloud-based platform that streamlines Resource Management reporting services across the organization. 
        It allows client-serving teams and resource managers to easily generate, store, and manage reports, providing real-time insights. 
        Integrated with Retain, it ensures accurate, accessible forecast data, enhancing decision-making and resource management.
      </div>
    </div>
    <div class="infoSection2">
      <div class="countContainer" *ngFor="let report of reportCount">
        <div class="countText">{{report.ReportCount}}</div>
        <div class="countType">{{report.ReportName}}</div>
      </div>
    </div>
  </div>
</div>